import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';
import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';
import { TipoOperacaoService } from '../../../tipo_operacao/services/tipo_operacao.service';

@Component({
  selector: 'app-fast-tipo-operacao',
  templateUrl: './fast-tipo-operacao.component.html',
  styleUrls: ['./fast-tipo-operacao.component.scss'],
  providers: [TipoOperacaoService]
})
export class FastTipoOperacaoComponent implements OnInit {
  form: UntypedFormGroup;

  loading = false;

  constructor(
    protected fb: UntypedFormBuilder,
    protected entityService: TipoOperacaoService,
    protected snackBar: MatSnackBar,
    protected dialogRef: MatDialogRef<FastTipoOperacaoComponent>,
    protected tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
  }

  onSubmit() {
    this.loading = true;
    const entity = {
      domain_org_id: this.tokenService.getDomain().id,
      ...this.form.value
    };
    if (this.form.valid) {
      this.entityService
        .insert(entity)
        .pipe(filter(result => !!result))
        .subscribe(
          formPgmt => {
            this.loading = false;
            this.dialogRef.close(formPgmt);
            this.snackBar.open(
              'Tipo de operação cadastrada com sucesso.',
              'X',
              {
                duration: 2000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['msg-success']
              }
            );
          },
          () => {
            this.loading = false;
            this.snackBar.open('Erro ao cadastrar tipo de operação.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }
}
